var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuContacts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 25.22 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27,0a8.38,8.38,0,1,0,8.4,8.37A8.4,8.4,0,0,0,27,0Zm0,14.67a6.3,6.3,0,1,1,6.33-6.3A6.33,6.33,0,0,1,27,14.67Z",
    transform: "translate(-14.38)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.1,19.41,31.83,17a1.07,1.07,0,0,0-.91,0A8.7,8.7,0,0,1,27,18H27a8.74,8.74,0,0,1-3.91-1,1.05,1.05,0,0,0-.9,0L16.89,19.4c-.1,0-2.51,1-2.51,4.46V31a1,1,0,0,0,1,1H38.56a1,1,0,0,0,1-1v-7.1C39.6,20.51,37.35,19.51,37.1,19.41Zm.43,4.45v6.07H16.45V23.86c0-2,1.17-2.52,1.23-2.54l4.89-2.22a10.46,10.46,0,0,0,8.84,0l4.9,2.22S37.53,21.84,37.53,23.86Z",
    transform: "translate(-14.38)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuContacts);
export default __webpack_public_path__ + "static/media/menu-contacts.19cd6911.svg";
export { ForwardRef as ReactComponent };